export const replaceUnderScoreWithHyphen = (name = '') => name.replace(/_/g, '-');
